// S-137: saas-admin の v2 画面（docs/UI-GUIDE.md）で共有するクラス。
// 白カード（30/26）と、ゼブラ行の上に置く行内ボタン（S-136 の判断: 白面・灰面のどちらとも同色に
// ならないよう 面あり = ブランド色 / 注意色、面なし = 危険色 / 中立 の 4 系統）。
// ページ内に BTN_* 定数を置かず、ここか @kawai/ui の Button を使う。

/** 白カード。ページ地色（--background）の上に置く。 */
export const CARD = 'rounded-xl bg-white px-[30px] py-[26px]';
/** カードの見出し（18px / 600）。 */
export const CARD_TITLE = 'text-h-card font-semibold text-ink';
/** ID / 時刻の等幅（S-132 で据え置きが決まった font-mono。サイズは 14px）。 */
export const MONO = 'font-mono text-label';

const ROW_BTN_BASE =
  'inline-flex items-center whitespace-nowrap rounded-lg px-3.5 py-1.5 text-label font-medium disabled:cursor-not-allowed disabled:opacity-50';
/** 行内の主操作（ブランド色の面）。 */
export const ROW_BTN_BRAND = `${ROW_BTN_BASE} bg-brand-tint text-brand-ink hover:opacity-90`;
/** 行内の注意を要する操作（注意色の面）。 */
export const ROW_BTN_WARNING = `${ROW_BTN_BASE} bg-warning-tint text-warning-ink hover:opacity-90`;
/** 行内の破壊的操作（面なし / 危険色の文字）。 */
export const ROW_BTN_DANGER = `${ROW_BTN_BASE} text-danger-ink hover:bg-surface-3`;
/** 行内の中立な操作（面なし / 補助文の色）。 */
export const ROW_BTN_GHOST = `${ROW_BTN_BASE} text-ink-2 hover:bg-surface-3`;
